import _ from 'lodash';
import { getRouteStep } from '../components/App/Init/RouteStep';
import { store } from '../redux/stores';

const resolveRoutes = (typeMER) => {
    if (typeMER !== undefined) {
        return getRouteStep(typeMER);
    }
    const fromStore = store.getState()?.init?.data?.DemandeDevis?.TypeMER ?? null;
    return getRouteStep(fromStore);
};

export const routesAffichees = (routes) => {
    let cloneRoute = _.cloneDeep(routes);
    cloneRoute = _.reject(cloneRoute, ['slug', 'recontact']);
    cloneRoute = _.reject(cloneRoute, ['slug', 'faq']);
    return cloneRoute;
};

export const getStepBySlug = (slug, typeMER) => {
    const route = _.find(resolveRoutes(typeMER), ['slug', slug]);
    return route && route !== -1 ? route.step : '';
};

export const getSlugByStep = (step, typeMER) => {
    const route = _.find(resolveRoutes(typeMER), ['step', step]);
    return route && route !== -1 ? route.slug : '';
};

export const getTitleByStep = (step, typeMER) => {
    const route = _.find(resolveRoutes(typeMER), ['step', step]);
    return route && route !== -1 ? route.title : '';
};
